import isClient from 'utils/isClient'

const getUserAgent = () => {
  if (!isClient()) {
    return false
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }

  return 'unknown'
}

export const ChromeCondition = isClient()
  ? (!!window.chrome &&
      (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    navigator.userAgent.indexOf('Chrome') >= 0
  : false

export const isSafari = () =>
  !!window.safari ||
  (navigator.userAgent.indexOf('Safari') >= 0 && !ChromeCondition)

export default getUserAgent
